import { date } from "quasar";

export default function useTime() {
  const todayTS = (): number => {
    const today = new Date();
    return new Date(date.formatDate(today, "YYYY-MM-DD")).getTime();
  };

  const getWeekDateRange = (weekNum: number, planStartDt: string): Date[] => {
    const weekStartDt = date.addToDate(planStartDt, {
      days: (weekNum - 1) * 7,
    });

    const weekEndDt = date.addToDate(weekStartDt, {
      days: 6,
    });

    return [weekStartDt, weekEndDt];
  };

  return {
    todayTS,
    getWeekDateRange,
  };
}
